import ModalService from './modal';

const modalService = new ModalService();
export { ModalService, modalService };
